import { fmtDate, type UserActivity } from "../activity";

export default function ActivityExams({ activity }: { activity: UserActivity }) {
  const exams = activity.examAttempts;

  if (exams.length === 0) {
    return (
      <p className="text-sm text-foreground-500 text-center py-8">
        Bu öğrenci henüz deneme sınavına girmemiş.
      </p>
    );
  }

  return (
    <div className="rounded-lg border border-background-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200 bg-background-100/60">
              <th className="text-left px-3 py-2.5 font-semibold text-foreground-600 whitespace-nowrap">
                Sınav
              </th>
              <th className="text-left px-3 py-2.5 font-semibold text-foreground-600 whitespace-nowrap">
                Tarih
              </th>
              <th className="text-center px-3 py-2.5 font-semibold text-foreground-600 whitespace-nowrap">
                Net
              </th>
              <th className="text-center px-3 py-2.5 font-semibold text-foreground-600 whitespace-nowrap">
                Doğru
              </th>
              <th className="text-center px-3 py-2.5 font-semibold text-foreground-600 whitespace-nowrap">
                Yanlış
              </th>
              <th className="text-center px-3 py-2.5 font-semibold text-foreground-600 whitespace-nowrap">
                Boş
              </th>
              <th className="text-center px-3 py-2.5 font-semibold text-foreground-600 whitespace-nowrap">
                Sıralama
              </th>
            </tr>
          </thead>
          <tbody>
            {exams.map((e) => (
              <tr
                key={e.id}
                className="border-b border-background-100 last:border-0 hover:bg-background-100/40 transition-colors"
              >
                <td className="px-3 py-2.5 font-medium text-foreground-900 whitespace-nowrap">
                  {e.exam_name}
                </td>
                <td className="px-3 py-2.5 text-foreground-600 whitespace-nowrap">
                  {fmtDate(e.taken_on)}
                </td>
                <td className="px-3 py-2.5 text-center font-semibold text-foreground-950 whitespace-nowrap">
                  {e.net.toFixed(2)}
                </td>
                <td className="px-3 py-2.5 text-center text-foreground-700 whitespace-nowrap">
                  {e.correct_count}
                </td>
                <td className="px-3 py-2.5 text-center text-foreground-700 whitespace-nowrap">
                  {e.wrong_count}
                </td>
                <td className="px-3 py-2.5 text-center text-foreground-700 whitespace-nowrap">
                  {e.blank_count}
                </td>
                <td className="px-3 py-2.5 text-center text-foreground-600 whitespace-nowrap">
                  {e.rank ?? "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}